import Dictionary from "./classes/dictionary";

export default function extractFormData(data:any, formdata:FormData | Dictionary, complemented:string = ""){
  Object.keys(data).forEach(name=>{
    let item = data[name];
    if(item instanceof Array){
      if(item.length > 0){
        item.forEach((data2:any,key:number)=>{
          if(data2 instanceof Object){
            extractFormData(data2,formdata,complemented+(complemented?`[${name}]`:name)+`[${key}]`);
          } else {
            formdata.append(complemented+(complemented?`[${name}]`:name)+`[${key}]`, data2);
          }
        });
      }
    } else {
      if(item instanceof Object){
        extractFormData(item,formdata,complemented+(complemented?`[${name}]`:name));
      } else {
        if(item){
          formdata.append(complemented+(complemented?`[${name}]`:name), item);
        }
      }
    }
  });
}